module.exports = __webpack_public_path__ + "img/PPT版_00.b64b0077.png";